import { render, staticRenderFns } from "./courseVideo.vue?vue&type=template&id=5d7dab9a&scoped=true&"
import script from "./courseVideo.vue?vue&type=script&lang=js&"
export * from "./courseVideo.vue?vue&type=script&lang=js&"
import style0 from "./courseVideo.vue?vue&type=style&index=0&id=5d7dab9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7dab9a",
  null
  
)

export default component.exports